module.exports = __webpack_public_path__ + "71b333e7d7606b0d6d569f7ee8374c2c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/GC_PUBLIKUM.jpg
// module id = 758
// module chunks = 0